import React, { Component } from "react";
import { Link } from "react-router-dom";
// Layout
import Header from "../layout/header/header1";
import bannerImg from "../../images/robotics-for-good/banner.png";
import { withTranslation } from "react-i18next";

class RoboticsForGoodJourney extends Component {
  constructor(props) {
    super(props);
    this.wrapperRef = React.createRef();
    this.state = {};
  }

  componentDidMount() {}

  render() {
    const { t } = this.props;

    return (
      <>
        <Header />
        <div className="page-content">
          <div className="content-block" id="content-area">
            {/* 🖼️ 页面顶部横幅 */}
            <div
              className="page-banner"
              style={{ backgroundImage: `url(${bannerImg})` }}
            >
              <div className="container">
                <div className="page-banner-entry">
                  <h1 className="text-white">{t("Robotics_For_Good_Journey_Title")}</h1>
                </div>
              </div>
            </div>

            {/* 🧭 面包屑导航 */}
            <div className="breadcrumb-row">
              <div className="container">
                <ul className="list-inline">
                  <li>
                    <Link to="/">{t("Robotics_For_Good_Journey_LinkHome")}</Link>
                  </li>
                  <li>{t("Robotics_For_Good_Journey_Link")}</li>
                </ul>
              </div>
            </div>

            {/* 📅 Event Timeline Section */}
            <div className="section-full content-inner bg-white m-t30">
              <div className="container">
                <div className="section-head style-1 text-center">
                  <h2 className="title">Event Timeline</h2>
                </div>

                <div className="row">
                  <div className="col-lg-12">
                    <h4>📍 State Team Selection – by the end of November 2025</h4>
                    <p>
                      All states finalize their Junior and Senior teams for the national competition.
                    </p>

                    <h4>🏟 Australian National Competition – 28th March, 2026</h4>
                    <p>
                      Venue: Glenunga International High School, Adelaide. All state-selected teams compete at the national level.
                    </p>

                    <h4>🌍 Grand Finale – July 2026</h4>
                    <p>
                      Location: Geneva, Switzerland. The winning Junior and Senior teams from Australia represent the country at the Robotics for Good Youth Challenge Global Summit 2026. Travel and accommodation are self-funded.
                    </p>

                    <hr className="m-t30 m-b30" />

                    <h4>📢 Updates</h4>
                    <p>
                      Details of each stage — including training sessions, competition highlights, team results, and media coverage — will be published here after each milestone is completed. Stay tuned for updates as the journey unfolds.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* END Section */}
          </div>
        </div>
      </>
    );
  }
}

export default RoboticsForGoodJourney = withTranslation()(RoboticsForGoodJourney);
